import { api } from '@api'
import { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'

export type ColorLabel = {
  id: string
  name: string
  color: string
  contactAccountIds: string[]
}

const fetchColorLabels = async ({ pageParam = '0', q }: FetchParams): Promise<PaginatedResponse<ColorLabel>> => {
  const url = q
    ? `/color-labels?q=${q}` + `&page=${pageParam}`
    : `/color-labels?page=${pageParam}`
  const { data } = await api.get<PaginatedResponse<ColorLabel>>(url)
  return data
}

export const usePaginateColorLabels = (q?: string) => {
  return usePaginate<ColorLabel>('color-labels', fetchColorLabels, { q })
}

